import React, { Component } from 'react';
import PropTypes from 'prop-types';
import WveInputNumber from '../WveInputNumber/WveInputNumber';

const MULTIPLE = 'multiple';

class WveInputIntegerPair extends Component {
  render() {
    const { value, title, removable, ...otherProps } = this.props;
    const isMultiple = value === MULTIPLE || typeof value !== 'object';
    const valuesToShow = isMultiple ? [MULTIPLE, MULTIPLE] : value;
    return (<div
      className={`wve-input-pair
        ${removable && ' wve-input-removable '}
      `}
    >
      {valuesToShow.map((value, index) =>
        <WveInputNumber
          title={title[index]}
          value={value}
          positionInArray={index}
          {...otherProps}
          key={`${title[index]}-${index}`}
        />,
      )}
    </div>);
  }
}

WveInputIntegerPair.defaultProps = {
  title: '',
  removable: false,
};

WveInputIntegerPair.propTypes = {
  title: PropTypes.array.isRequired,
  value: PropTypes.array.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  handleUpdate: PropTypes.func,
  onKeyUp: PropTypes.func,
  placeholder: PropTypes.string,
};

export default WveInputIntegerPair;



// WEBPACK FOOTER //
// ./app/javascript/packs/Shared/components/WveInputs/WveInputIntegerPair/WveInputIntegerPair.jsx